import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const expandableAreaStyles = makeStyles((theme: Theme) =>
    createStyles({
        expandArea: {
            display: "flex",
            backgroundColor: "rgba(39, 10, 220, 0)",
            padding: "20px 10px 20px 0px",
        },
        graphWidth: { width: "400px", marginLeft: "50px" },
        gridComponent: {
            display: "flex",
            width: "250px",
        },
    })
);
